export const COLOR_THEMES = {
  ocean: {
    id: 'ocean',
    name: 'Ocean Blue',
    description: 'Classic blue & orange brand palette',
    preview: ['#2563eb', '#f97316'],
    vars: {
      '--primary-50': '239 246 255',
      '--primary-100': '219 234 254',
      '--primary-200': '191 219 254',
      '--primary-300': '147 197 253',
      '--primary-400': '96 165 250',
      '--primary-500': '59 130 246',
      '--primary-600': '37 99 235',
      '--primary-700': '29 78 216',
      '--primary-800': '30 64 175',
      '--primary-900': '30 58 138',
      '--secondary-400': '251 146 60',
      '--secondary-500': '249 115 22',
      '--secondary-600': '234 88 12',
      '--accent-glow': '59 130 246',
    },
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset Blaze',
    description: 'Warm orange primary with deep blue accents',
    preview: ['#ea580c', '#1e40af'],
    vars: {
      '--primary-50': '255 247 237',
      '--primary-100': '255 237 213',
      '--primary-200': '254 215 170',
      '--primary-300': '253 186 116',
      '--primary-400': '251 146 60',
      '--primary-500': '249 115 22',
      '--primary-600': '234 88 12',
      '--primary-700': '194 65 12',
      '--primary-800': '154 52 18',
      '--primary-900': '124 45 18',
      '--secondary-400': '96 165 250',
      '--secondary-500': '59 130 246',
      '--secondary-600': '37 99 235',
      '--accent-glow': '249 115 22',
    },
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    description: 'Deep indigo with vibrant cyan highlights',
    preview: ['#4f46e5', '#06b6d4'],
    vars: {
      '--primary-50': '238 242 255',
      '--primary-100': '224 231 255',
      '--primary-200': '199 210 254',
      '--primary-300': '165 180 252',
      '--primary-400': '129 140 248',
      '--primary-500': '99 102 241',
      '--primary-600': '79 70 229',
      '--primary-700': '67 56 202',
      '--primary-800': '55 48 163',
      '--primary-900': '49 46 129',
      '--secondary-400': '34 211 238',
      '--secondary-500': '6 182 212',
      '--secondary-600': '8 145 178',
      '--accent-glow': '99 102 241',
    },
  },
  emerald: {
    id: 'emerald',
    name: 'Emerald',
    description: 'Fresh green with golden orange accents',
    preview: ['#059669', '#f59e0b'],
    vars: {
      '--primary-50': '236 253 245',
      '--primary-100': '209 250 229',
      '--primary-200': '167 243 208',
      '--primary-300': '110 231 183',
      '--primary-400': '52 211 153',
      '--primary-500': '16 185 129',
      '--primary-600': '5 150 105',
      '--primary-700': '4 120 87',
      '--primary-800': '6 95 70',
      '--primary-900': '6 78 59',
      '--secondary-400': '251 191 36',
      '--secondary-500': '245 158 11',
      '--secondary-600': '217 119 6',
      '--accent-glow': '16 185 129',
    },
  },
  royal: {
    id: 'royal',
    name: 'Royal Purple',
    description: 'Regal purple with rose gold accents',
    preview: ['#7c3aed', '#f43f5e'],
    vars: {
      '--primary-50': '245 243 255',
      '--primary-100': '237 233 254',
      '--primary-200': '221 214 254',
      '--primary-300': '196 181 253',
      '--primary-400': '167 139 250',
      '--primary-500': '139 92 246',
      '--primary-600': '124 58 237',
      '--primary-700': '109 40 217',
      '--primary-800': '91 33 182',
      '--primary-900': '76 29 149',
      '--secondary-400': '251 113 133',
      '--secondary-500': '244 63 94',
      '--secondary-600': '225 29 72',
      '--accent-glow': '139 92 246',
    },
  },
  monochrome: {
    id: 'monochrome',
    name: 'Monochrome',
    description: 'Sleek black & white with orange pops',
    preview: ['#171717', '#f97316'],
    vars: {
      '--primary-50': '250 250 250',
      '--primary-100': '245 245 245',
      '--primary-200': '229 229 229',
      '--primary-300': '212 212 212',
      '--primary-400': '163 163 163',
      '--primary-500': '115 115 115',
      '--primary-600': '82 82 82',
      '--primary-700': '64 64 64',
      '--primary-800': '38 38 38',
      '--primary-900': '23 23 23',
      '--secondary-400': '251 146 60',
      '--secondary-500': '249 115 22',
      '--secondary-600': '234 88 12',
      '--accent-glow': '249 115 22',
    },
  },
};

export const DEFAULT_THEME_ID = 'ocean';

export const ROUTE_LABELS = {
  dashboard: 'Overview',
  client: 'Client Management',
  employee: 'Employee Management',
  blogs: 'Blogs',
  questions: 'Question Management',
  admin: 'Admin',
  payments: 'Payment Management',
  referrals: 'Referral Management',
  meetings: 'Meeting Management',
  contacts: 'Contacts Hub',
  'webinar-forms': 'Webinar Forms',
  promocodes: 'Promo Codes',
  'recycle-bin': 'Recycle Bin',
  'login-history': 'Login History',
  analytics: 'Analytics',
  'email-campaigns': 'Email Campaigns',
  events: 'Events',
  templates: 'Email Templates',
  scheduler: 'Campaign Scheduler',
  logs: 'Campaign Logs',
  leads: 'Lead Management',
  documents: 'Documents',
  cms: 'Website CMS',
  pages: 'Pages',
  'why-bookscomply': 'Why BooksComply',
  'help-center': 'Help Center',
  'legal-pages': 'Legal Pages',
  'zoho-event': 'Zoho Event',
  'industry-pages': 'Industry Pages',
  pricing: 'Pricing Page',
  'blog-page': 'Blog Page',
  'usa-company-formation': 'USA Company Formation',
  'tax-return': 'Tax Return',
  bookkeeping: 'Bookkeeping',
  'cfo-advisory': 'CFO Advisory',
  'zoho-advisory': 'Zoho Advisory',
};
